import { useEffect, useState } from 'react';
import { fetchVersion } from '../services/version.api';

export function useVersion() {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [notFound, setNotFound] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let alive = true;
    const controller = new AbortController();

    (async () => {
      try {
        setLoading(true);
        const res = await fetchVersion(controller.signal);
        if (!alive) return;
        setData(res);
      } catch (err) {
        if (!alive) return;
        if (err?.message?.includes(' 404 ')) {
          setNotFound(true);
        } else {
          setError(err?.message || 'Failed to load version information');
        }
      } finally {
        if (alive) setLoading(false);
      }
    })();

    return () => {
      alive = false;
      controller.abort();
    };
  }, []);

  return { loading, data, notFound, error };
}
